import { string, number, array, oneOfType, bool } from 'prop-types';
import styled from 'styled-components';

// Import components
import { Basic } from '../Basic';
import { SliderItem } from '../components/SliderItem';
import { Heading } from 'components/elements';
import { VodSectionButton } from 'components/views/vod/components/buttons/VodSectionButton/VodSectionButton';

// Import styles
import { sectionBackground } from 'components/styles';

const Container = styled.div`
	width: 100%;
	background-color: black;
	position: relative;
	display: grid;
	grid-template-rows: 100px auto 80px;
	grid-gap: 20px;

	${({ backgroundImage }) => backgroundImage && sectionBackground(backgroundImage)}
`;

const GradientAfter = styled.div`
	position: absolute;
	top: -35vh;
	height: 35vh;
	width: 100%;
	z-index: -1;
	background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.8) 40%, rgba(0, 0, 0, 0.2) 70%, rgba(0, 0, 0, 0) 100%);
`;

const GradientBefore = styled.div`
	position: absolute;
	bottom: -35vh;
	height: 35vh;
	width: 100%;
	z-index: -1;
	background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 40%, rgba(0, 0, 0, 0.4) 70%, rgba(0, 0, 0, 0) 100%);
`;

const BgGradient = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	overflow: hidden;
	top: 0;
	display: flex;
	justify-content: center;
	background-color: rgba(10, 21, 45);
`;

const Gradient = styled.div`
	height: 300%;
	width: 150%;
	position: absolute;
	top: -100px;
	background: radial-gradient(
		closest-side,
		rgb(31, 88, 123) 0%,
		rgba(31, 88, 123, 0.8) 20%,
		rgba(31, 88, 123, 0.3) 50%,
		rgba(31, 88, 123, 0.1) 80%,
		rgba(31, 88, 123, 0.02) 90%,
		rgba(31, 88, 123, 0) 100%
	);
`;

const Header = styled.div`
	height: 100%;
	width: 100%;
	z-index: 2;
	padding: 0 90px 0 90px;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
`;

const Content = styled.div`
	width: 100%;
	height: 100%;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	overflow: hidden;
`;

const Title = styled(Heading.First)`
	color: ${({ theme }) => theme.white};
	font-size: 2.4rem;
	margin: 0;
`;

const GapBefore = styled.div`
	height: 80px;
`;

const GapAfter = styled.div`
	height: 20px;
`;

export function Promo(props) {
	const { content, name, id, label, showGradientAfter, showGradientBefore, showGapBefore, showGapAfter, backgroundImage } = props;

	return (
		<>
			{showGapBefore && <GapBefore />}
			<Container backgroundImage={backgroundImage}>
				{showGradientAfter && <GradientAfter />}
				<Header>
					<Title>{name}</Title>
					<VodSectionButton sectionId={id} sectionTitle={name} />
				</Header>
				<Content>
					<Basic
						headerHeight={160}
						spaceBetweenItems={36}
						itemsToShow={6}
						itemsList={content}
						itemResolutionHeight={9}
						itemResolutionWidth={6}
						headerSliderGap={-160}
						verticalPadding={90}
						horizontalPadding={80}
						renderItemComponent={({ data, height, width }) => <SliderItem sectionLabel={label} data={data} height={height} width={width} />}
					/>
				</Content>
				{!backgroundImage && (
					<BgGradient>
						<Gradient />
					</BgGradient>
				)}
				{showGradientBefore && <GradientBefore />}
			</Container>
			{showGapAfter && <GapAfter />}
		</>
	);
}

Promo.defaultProps = {
	showGradientAfter: false,
	showGradientBefore: false,
	showGapBefore: false,
	showGapAfter: false,
	backgroundImage: false
};

Promo.propTypes = {
	id: oneOfType([string, number]).isRequired,
	name: string.isRequired,
	label: string.isRequired,
	content: array.isRequired,
	showGradientAfter: bool,
	showGradientBefore: bool,
	showGapBefore: bool,
	showGapAfter: bool,
	backgroundImage: oneOfType([string, bool])
};
